var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.287,
    y1: 0.176,
    x2: 0.503,
    y2: 0.504,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.499,
    y1: 0.498,
    x2: 0.761,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d74a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c73d28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    x2: 0.5,
    y2: 0.943,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.149
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.031
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 0.023,
    x2: 0.5,
    y2: 1.018,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e05141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de4735"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2216 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    transform: "translate(2216 361)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2220 372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.773,53.2H6.552A3.552,3.552,0,0,1,3,49.648v-38.1A3.552,3.552,0,0,1,6.552,8H58.771a3.553,3.553,0,0,1,3.554,3.552V49.646A3.553,3.553,0,0,1,58.773,53.2Z",
    transform: "translate(-3 -8)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.71,51.963H8L60.263,11V48.41A3.552,3.552,0,0,1,56.71,51.963Z",
    transform: "translate(-0.937 -6.762)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.552,8h3.51V53.2H6.552A3.552,3.552,0,0,1,3,49.648v-38.1A3.552,3.552,0,0,1,6.552,8Zm52.22,0h-3.51V53.2h3.51a3.552,3.552,0,0,0,3.552-3.552v-38.1A3.552,3.552,0,0,0,58.773,8Z",
    transform: "translate(-3 -8)",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.773,53.2H41.865L3,12.923V11.554A3.553,3.553,0,0,1,6.552,8H58.771a3.553,3.553,0,0,1,3.554,3.552V49.646A3.553,3.553,0,0,1,58.773,53.2Z",
    transform: "translate(-3 -8)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.661,15.205l-28,20.281-28-20.281A4.025,4.025,0,0,1,3,11.945v-.393A3.552,3.552,0,0,1,6.552,8H58.771a3.553,3.553,0,0,1,3.554,3.552v.393A4.025,4.025,0,0,1,60.661,15.205Z",
    transform: "translate(-3 -8)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.773,8h-.424L32.663,26.606,6.976,8H6.552A3.552,3.552,0,0,0,3,11.552v.393a4.025,4.025,0,0,0,1.664,3.26l28,20.281,28-20.281a4.025,4.025,0,0,0,1.664-3.26v-.393A3.552,3.552,0,0,0,58.773,8Z",
    transform: "translate(-3 -8)",
    fill: "url(#f)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail-icon.e4795d32.svg";
export { ForwardRef as ReactComponent };